// extracted by mini-css-extract-plugin
export default {"container":"Game_container__DLqjH","status":"Game_status__YCySq","info":"Game_info__J6RFl","row":"Game_row__fa3G6","button":"Game_button__6rviB"};